import { BRAND } from "../../../constants"
import { normaliseLink } from "../../../controllers/helpers/normaliseLink"
import { Submenu } from "../../../models/interfaces/MegaMenu.interface"
import CloseTitle from "./CloseTitle"

type MenuProps = {
  links: Submenu[]
  title: string
}

const Menu = ({ links, title }: MenuProps) => {
  return (
    <ul className='unordered-list'>
      <CloseTitle title={title} />
      <br />
      <div
        style={{
          maxWidth: `${BRAND.layout.content}px`,
          width: '100%',
          scrollBehavior: 'smooth',
          overflow: 'auto'
        }}>
        <section className='direction'>
          {links?.map((submenu, i) => (
            <li className='links-list' key={`link-list-${submenu.id}`}>
              <h5 className='links-header'>{submenu.title}</h5>
              {/* This should also be plural technically to make it more dev-friendly but it's coming from the backend like this */}
              {submenu?.link?.map(({ url = '', title = '' }) => (
                <a className='anchor' key={`link-anchor-${url}`} href={normaliseLink(url)}>
                  {title}
                </a>
              ))}
            </li>
          ))}
        </section>
      </div>
      <style jsx>
        {`
          .direction {
            display: flex;
            flex-direction: row;
          }
          .unordered-list {
            min-height: 420px;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: center;
            align-items: flex-start;
            padding: 24px 36px 48px;
            list-style: none;
          }
          .anchor {
            font-size: 16px;
            font-weight: 500;
            margin: 6px 0px;
            text-decoration: none;
            cursor: pointer;
          }
          .links-header {
            font-weight: 600;
            font-size: 18px;
            margin: 6px 0px;
          }
          .links-list {
            padding-right: 64px;
            min-width: 220px;
            display: flex;
            margin-bottom: 32px;
            flex-direction: column;
          }

          @media screen and (max-width: ${BRAND.media.average}px) {
            .links-list {
              min-width: 140px;
              padding-right: 48px;
            }
          }
          @media screen and (max-width: ${BRAND.media.medium}px) {
            .links-list {
              min-width: 130px;
              padding-right: 36px;
            }
            .anchor {
              font-size: 14px;
            }
            .links-header {
              font-size: 16px;
            }
          }
          @media screen and (max-width: ${BRAND.media.small}px) {
            .direction {
              display: flex;
              flex-direction: column;
            }
            .ordered-list {
              flex-direction: column;
              flex-wrap: nowrap;
              justify-content: flex-start;
              align-items: flex-start;
              padding: 24px 24px 72px;
              width: 100%;
              max-height: calc(100vh - 100px);
              overflow: auto;
            }
          }
        `}
      </style>
    </ul>
  )
}

export default Menu